import { TZDate } from '@date-fns/tz';
import { format } from 'date-fns';
import type { TripOverview } from '~/services/engine-ts';

export const isTripStartInPast = (overview: TripOverview | undefined, isTemplateDateUnset = false) => {
  const startDate = overview?.items.find((item) => item.isFirstItem)?.startDate;
  return (
    !isTemplateDateUnset && !!startDate && startDate <= format(new TZDate(Date.now(), 'Europe/London'), 'yyyy-MM-dd')
  );
};
